import Icon from '@forwardflow/ui/Icons'
import { Collapse, type CollapseProps } from 'antd'
import { useState } from 'react'

export const TermsOfService = () => {
   const [activeKey, setActiveKey] = useState<string | string[]>([])

   const previewText =
      'By activating this campaign within Forward Flow, I hereby affirm and certify that all contacts included in this campaign have expressly opted in to receive communications.'

   const isExpanded = Array.isArray(activeKey)
      ? activeKey.includes('1')
      : activeKey === '1'

   const items: CollapseProps['items'] = [
      {
         key: '1',
         label: (
            <div>
               <p className="text-[14px] font-medium text-white">
                  Terms of Service
               </p>
               {!isExpanded && (
                  <p className="text-[12px] text-white/70 mt-1">
                     {previewText}...
                  </p>
               )}
            </div>
         ),
         children: (
            <>
               <p className="text-[12px] text-white/70 -mt-3">
                  By activating this campaign within Forward Flow, I hereby
                  affirm and certify that all contacts included in this campaign
                  have expressly opted in to receive communications. I
                  understand and acknowledge that:
               </p>
               <ul className="text-[12px] text-white/70 list-disc pl-4 flex gap-y-1 flex-col mt-1">
                  <li>
                     Contacting individuals who have not provided proper consent
                     constitutes a violation of the Telephone Consumer
                     Protection Act (TCPA) and other applicable consumer
                     protection laws.
                  </li>
                  <li>
                     Forward Flow's automation systems, including voice, SMS,
                     and email functionality, are strictly intended for use with
                     leads who have granted prior express written consent to be
                     contacted.
                  </li>
                  <li>
                     I accept full responsibility for ensuring compliance with
                     all applicable laws and regulations governing consumer
                     communications.
                  </li>
                  <li>
                     Misuse of Forward Flow's systems to contact non-opted-in
                     leads may result in suspension or termination of services,
                     and I agree to indemnify and hold harmless Forward Flow,
                     LLC from any claims, damages, or liabilities arising from
                     such misuse.
                  </li>
               </ul>
               <p className="text-[12px] text-white/70 mt-1">
                  By proceeding, I confirm that all leads in this campaign meet
                  the above consent requirements.
               </p>
            </>
         ),
      },
   ]

   const onChange = (key: string | string[]) => {
      setActiveKey(key)
   }

   return (
      <>
         <Collapse
            className="px-3 py-4 rounded-none "
            expandIconPosition="end"
            ghost
            items={items}
            activeKey={activeKey}
            onChange={onChange}
            expandIcon={({ isActive }) => (
               <Icon
                  name="arrow-down"
                  className={`fill-white transition-transform ${
                     isActive ? '-rotate-180' : ''
                  }`}
               />
            )}
         />
      </>
   )
}
